import Spacing from '@able/react/dist/Spacing';
import TextStyle from '@able/react/dist/TextStyle';
import * as React from 'react';
import {ActivityState, ActivityStateLookup} from '@applications/order-tracker/config/order-tracker-new-common/constants';

interface IGettingThingsReadyNotStartedOrInProgressComponent {
    msg: string;
}

interface IGettingThingsReadyCompletedComponent {
    msg: string
}

export interface IProgressTrackerGettingThingsReady {
    message: string,
    appendInstallationDetails: boolean,
    progressStage: string,
    state: string
}

const listStyles = {
    listStyleType: 'disc',
    marginLeft: '1.125rem'
};

const GettingThingsReadyNotStartedOrInProgressComponent = (props: IGettingThingsReadyCompletedComponent) => {
    return (
        <div>
            <TextStyle alias="TextBodyShort">
            <p>{props.msg}</p>
        </TextStyle>
            <TextStyle alias="TextBodyShort">
            <ul style={listStyles}>
                <li>Check your requirements.</li>
                <li>Make changes to our network.</li>
                <li>Deliver devices to your nominated address.</li>
            </ul>
        </TextStyle>
        </div>
    )
};

const GettingThingsReadyCompletedComponent = (props: IGettingThingsReadyNotStartedOrInProgressComponent) => {
    return (
        <div>
            <TextStyle alias="TextBodyShort">
                <p>{props.msg}</p>
            </TextStyle>
            <TextStyle alias="TextBodyShort">
                <ul style={listStyles}>
                    <li>Checked your requirements.</li>
                    <li>Made the necessary changes to our network.</li>
                    <li>Delivered any new devices.</li>
                    <li>Completed any required infrastructure build and installation activities.</li>
                </ul>
            </TextStyle>
        </div>
    )
};

// Content for Orders where progress state is Not Started or In Progress AND there are installation details to be displayed.
export const ProgressTrackerActivatingServiceInProgressComponent = (props: IProgressTrackerGettingThingsReady) => {
    return (
        <div>
            <TextStyle alias="TextBodyShort">
                <p>{props.message}</p>
            </TextStyle>
            <Spacing top="spacing3x"/>
            <TextStyle alias="Label" element="h5">
                Installing devices
            </TextStyle>
            <TextStyle alias="TextBodyShort">
                <p>Once your service is activated, we can install your managed devices such as routers, switches and handsets.</p>
            </TextStyle>
        </div>
    )
}

export const ProgressTrackerGettingThingsReady = (props: IProgressTrackerGettingThingsReady) => {

    return (
        <div>
            {props.state === ActivityState.Completed ?
                <GettingThingsReadyCompletedComponent msg={props.message}/> : <GettingThingsReadyNotStartedOrInProgressComponent msg={props.message}/> }

            {props.appendInstallationDetails && props.state !== ActivityStateLookup.Completed ?
                <div><Spacing top="spacing3x"/><TextStyle alias="Label" element="h5">
                    Installing Devices and New Infrastructure
                </TextStyle><Spacing top="spacing1x"/><TextStyle alias="TextBodyShort">
                    <p>If we need to make changes to your site, we'll liaise with your designated Site Contact to
                        arrange any required appointments for:</p>
                </TextStyle><TextStyle alias="TextBodyShort">
                    <ul style={listStyles}>
                        <li>Site assessments</li>
                        <li>Site alterations or infrastructure build</li>
                        <li>Installation of devices.</li>
                    </ul>
                </TextStyle>
                </div>
                : null
            }

        </div>
    )
}
